import CloseBtn2 from './CloseBtn2'
export default CloseBtn2
